import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { getCategories } from "../data/category";

const Navbar = () => {
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await getCategories();
        setCategories(response);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);
  const [categories, setCategories] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeSubDropdown, setActiveSubDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  // detect mobile
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 900);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleProductsClick = (e) => {
    if (isMobile) {
      e.preventDefault();
      setDropdownOpen(!dropdownOpen);
    } else {
      navigate("/products");
    }
  };

  return (
    <header className="navbar">
      <div className="nav-container">
        {/* LOGO */}
        <div className="nav-logo">
         <Link to={"/"} > <img src="/images/logo/logo.png" alt="JB Corporation Ahmedabad Gujarat" title="JB Corporation - Linear Motion Products Supplier" /></Link>
        </div>

        {/* HAMBURGER */}
        <div
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV LINKS */}
        <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
          <NavLink to="/" onClick={() => setMenuOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setMenuOpen(false)}>About</NavLink>

          {/* PRODUCTS DROPDOWN */}
          <div
            className={`dropdown ${dropdownOpen ? "open" : ""}`}
            onMouseEnter={() => !isMobile && setDropdownOpen(true)}
            onMouseLeave={() => !isMobile && setDropdownOpen(false)}
          >
            <NavLink
              to="/products"
              onClick={handleProductsClick}
              className={({ isActive }) => (isActive ? "active-link" : "")}
            >
              Products <i className="fa-solid fa-caret-down"></i>
            </NavLink>

            {/* Dropdown menu */}
            {dropdownOpen && (
              <div className="dropdown-menu">
                {categories.map((cat, index) => (
                  <NavLink
              to={`/${cat.name.toLowerCase().replace(/\s+/g, "-")}/${cat._id}`}
                    key={index}
                    className="dropdown-item"
                    onMouseEnter={() => !isMobile && setActiveSubDropdown(index)}
                    onMouseLeave={() => !isMobile && setActiveSubDropdown(null)}
                  >
                    <span>{cat.name}</span>
                    {!isMobile && <i className="fa-solid fa-angle-right"></i>}

                    {/* Subcategories (only desktop hover) */}
                    {!isMobile && activeSubDropdown === index && (
                      <div className="sub-dropdown-menu">
                        {cat.subcategories.map((sub, i) => (
                          <NavLink
                            key={i}
              to={`/${cat.name.toLowerCase().replace(/\s+/g, "-")}/${cat._id}`}
                            onClick={() => setMenuOpen(false)}
                          >
                            {sub}
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </NavLink>
                ))}
              </div>
            )}
          </div>

          <NavLink to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</NavLink>
          <NavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</NavLink>


           {/* Show these only in mobile view */}
                    <div className={`mobile-extra ${menuOpen ? "" : "hidden"}`}>
                        <div className="contact-info">
                            <p><a href="tel:+919265581679" target="_blank" rel="noreferrer"><strong>📞</strong> +91 92655 81679 </a></p>
                            <p><a href="mailto:jbcorporation2023@gmail.com" target="_blank" rel="noreferrer"><strong>📧</strong> jbcorporation2023@gmail.com</a></p>
                            <p><a href="https://maps.app.goo.gl/qmCBM58s4wLLsih7A" target="_blank" rel="noreferrer"><strong>📍</strong> Kathwada, Ahmedabad </a></p>
                        </div>

                        <div className="social-links">
                            <a href="tel:+91 9265581679" target="_blank" rel="noreferrer" className="social-btn phone">
                                <i className="fa-solid fa-phone"></i>
                            </a>
                            <a href="https://wa.me/919876543210" target="_blank" rel="noreferrer" className="social-btn whatsapp">
                                <i className="fa-brands fa-whatsapp"></i>
                            </a>
                            <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-btn linkedin">
                                <i className="fa-brands fa-linkedin-in"></i>
                            </a>
                            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-btn instagram">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        </div>



                    </div>
        </nav>
        {/* Buttons */}
                <div className="nav-buttons">
                    <a href="tel:+919265581679" className="btn call-btn"> <i className="fa-solid fa-phone"></i></a>
                    <a
                        href="https://maps.app.goo.gl/qmCBM58s4wLLsih7A"
                        target="_blank"
                        rel="noreferrer"
                        className="btn location-btn"
                    >
                        <i className="fa-solid fa-location-dot"></i>
                    </a>
                </div>
      </div>
    </header>
  );
};

export default Navbar;
